/**
 * @class
 * @param {array} content
 * @extends mkE.Base
 */
T.Slider = Class(
	/**
	 * @lends {T.Slider#}
	 */
	{

		/** @type {HTMLElement|null} */
		_listNode: null,

		/** @param {{content:Array|null,autoplay:Number|null}} par */
		__construct(par) {
			this.par = par || {};
			this.node = mkE({
				tag: 'div',
				className: 't-slider',
				els: [
					this._btnPrevNode = mkE({
						tag: 'a',
						className: 'ctrl ctrl-prev',
						onclick: this.prev,
						style: {
							display: 'none'
						},
						els: [
							D.svgIcon('arrow-left')
						]
					}),
					this._listNode = mkE({
						tag: 'div',
						className: 'wrapper'
					}),
					this._btnNextNode = mkE({
						tag: 'a',
						className: 'ctrl ctrl-next',
						onclick: this.next,
						style: {
							display: 'none'
						},
						els: [
							D.svgIcon('arrow-right')
						]
					})
				]
			});
			if (par.content) {
				this.setContent(par.content);
			}
			if (par.autoplay) {
				this.startAutoplay();
			}
			if (par.className) {
				addClassName(this.node, par.className);
			}
		},
		setContent(content) {
			clearNode(this._listNode);
			if (content instanceof HTMLElement) {
				while (content.childNodes.length) {
					this._listNode.appendChild(content.firstChild);
				}
			} else {
				mkE.appendTypeElement(this._listNode, content);
			}
			this.refresh();
		},
		onShow() {
			this.refresh();
		},
		onLeave() {
			if (this.par.autoplay) {
				clearTimeout(this._autoplayTimeout);
			}
		},
		refresh() {
			const count = this._listNode.children.length;
			const containerWidth = this._listNode.clientWidth;
			const itemWidth = count ? this._listNode.children[0].clientWidth : 0;
			let perPage = Math.floor(containerWidth / itemWidth);
			if (perPage === 1) {
				perPage++;
			}
			if (count > perPage && perPage > 0) {
				for (let i = 0; i < perPage; i++) {
					this._listNode.appendChild(this._listNode.children[i].cloneNode(true));
				}
				this._btnPrevNode.style.display = '';
				this._btnNextNode.style.display = '';
			}
		},
		/** @param {int} dir */
		scroll(dir) {
			const itemWidth = this._listNode.scrollWidth / this._listNode.children.length;
			const scrollTo = this._listNode.scrollLeft + itemWidth * dir;
			const max = this._listNode.scrollWidth - this._listNode.clientWidth;
			if (scrollTo > max) {
				this._listNode.scroll({
					top: 0,
					left: 0,
					behavior: 'instant'
				});
				this.scroll(dir);
			} else if (scrollTo < 0) {
				this._listNode.scroll({
					top: 0,
					left: max,
					behavior: 'instant'
				});
				this.scroll(dir);
			} else {
				this._listNode.scroll(scrollTo, 0);
			}
		},
		prev(e) {
			if (e !== undefined) {
				this.stopAutoplay();
				this.startAutoplay();
			}
			this.scroll(-1);
		},
		next(e) {
			if (e !== undefined) {
				this.stopAutoplay();
				this.startAutoplay();
			}
			this.scroll(1);
		},
		stopAutoplay() {
			clearTimeout(this._autoplayTimeout);
		},
		startAutoplay() {
			if (this.par.autoplay) {
				this._autoplayTimeout = setTimeout(this.onAutoplay, this.par.autoplay);
			}
		},
		onAutoplay() {
			this.next();
			this.startAutoplay();
		}
	},
	mkE.Base
);

